module.exports = __webpack_public_path__ + "img/japan-flag.945f1578.svg";